import React, { Component } from "react";
import { Link } from "react-router-dom";
class Item extends Component {
  render() {
    const { Icon, Title, Colour, RedirectPath } = this.props;

    return (
      <Link to={RedirectPath}>
        <div className="help-guide-section-item">
          <div className={"centred-content omni-color-" + Colour}>
            <div className={"icon-wrapper omni-brc-" + Colour}>
              <i className={"icon icon-" + Icon} />
            </div>
            <h4>{Title}</h4>
          </div>
        </div>
      </Link>
    );
  }
}

export default Item;
